import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: '1px';
`;

export const LabelWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin-bottom: ${rem(10)};
`;

export const StyledLabel = styled.label`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  font-weight: 600;
  margin-right: ${rem(8)};
`;

export const HeaderStyledLabel = styled.label`
  font-size: ${rem(16)};
  font-weight: 400;
  margin-right: ${rem(8)};
  color: ${({ theme }) => theme.colors.white};
  font-family: 'Pizza Hut';
`;

export const DropdownWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export const IconWrapper = styled.div`
  display: 'block';
  position: absolute;
  bottom: ${rem(4)};
  right: ${rem(8)};
  pointer-events: none;

  & svg {
    pointer-events: none;
  }
`;